import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from "@mui/material"
import React from "react"
import { contractStatusLookups } from "../../constants"

const ContractHistoryDialog = ({ data, open, onClose }) => <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
    <DialogTitle>История изменений</DialogTitle>
    <DialogContent>
        {data?.map(item => <React.Fragment key={item.id}>
            <Typography>
                {item.user} перевел(а) договор в статус "{contractStatusLookups[item.status]}"
            </Typography>
            <Typography variant="subtitle2" color="grey">
                {new Date(item.modified_at).toLocaleString()}
            </Typography>
            <Divider sx={{ my: 1 }} />
        </React.Fragment>)}
    </DialogContent>
    <DialogActions>
        <Button color="error" onClick={onClose}>
            Закрыть
        </Button>
    </DialogActions>
</Dialog>

export default ContractHistoryDialog
